import { Router } from "@angular/router";
import { PrivacyMetaModel } from "common/models/page-models/privacy/privacy-form-meta.model";
import { MetaModel, WidgetModel } from "common/models/utility-models/base-model";
import { SystemService } from "common/services/core-services/system.service";
import { FormWidgetService } from "../form-widget.service";
import { Injectable } from "@angular/core";
import { MentorFeedbackModel } from "common/models/page-models/mentor-feedback/mentor-feedback-data-model";
import { MentorFeedbackDataService } from "common/services/data-services/mentor-feedback/mentor-feedback-data.service";
import { MentorFeedbackMetaModel } from "common/models/page-models/mentor-feedback/mentor-feedback-meta.model";
import {
    SmMetaInputModel,
    SmMetaMultipleChoiceModel,
    SmMetaSelectModel,
    SmMetaTextAreaModel,
  } from "common/models/utility-models/meta-model";
import { environment } from "src/environments/environment";
import { API_URL } from "common/constants/sm-constants";
import { MentorFeedbackQuestionsDataService } from "common/services/data-services/mentor-feedback/mentor-feedback-questions-data.service";

@Injectable({
    providedIn: 'root'
})
export class MentorFeedbackWidgetService extends FormWidgetService<MentorFeedbackModel> {
    constructor(
        protected ds: MentorFeedbackDataService,
        protected ss: SystemService,
        protected router: Router,
        protected MentorFeedbackQuestion: MentorFeedbackQuestionsDataService,
    ) {
        super(ds);
    }

    getMetaModel(): MetaModel | MentorFeedbackMetaModel{
        const meta = new MentorFeedbackMetaModel();
        return meta.getMetaModel();
    }

    // override getUrlList(): any[] {
    //     const postObj = {}
    //     const urlList = [
    //         { url: environment.apiUrl + API_URL.viewMentorFeedbackQuestion, payload: postObj },
    //         { url: environment.apiUrl + API_URL.getStudentListForMentor, payload: postObj },
    //         // { url: environment.apiUrl + API_URL.InternshipstudentListBatchwise, payload: postObj },
    //     ];

    //     return urlList;
    // }

    override prepareMetaModel(dataModel:MentorFeedbackModel, metaModel: any, routeData: WidgetModel): Promise<MentorFeedbackMetaModel> {
        return new Promise<MentorFeedbackMetaModel>((resolve, reject) => {
            // console.log("DATAmodel", dataModel);
            metaModel.properties['selectStudent'].options = dataModel.studentsList;

            this.MentorFeedbackQuestion.postData({}).then((data)=>{
              dataModel.questions = data.details;
              // console.log('QUESTIONS', data);
          

            
              data.details.forEach((question) => {
                // dataModel.questions.forEach((question) => {
                // console.log("QUESTIOn", question);
                
                const { questionType  } = question;
        
                switch (questionType) {
                  case 0: // Input
                    // console.log(' case 0');
                    metaModel.properties[question.id] = new SmMetaInputModel(
                      String(question.id),
                      String(question.id),
                      "input",
                      true,
                      "col-12 col-md-6",
                      1,
                      1,
                      question.question,
                      "text",
                      "",
                      false,
                      true,
                      true,
                      false,
                      100,
                      1
                    );
                    break;
        
                  case 1: // Single Choice
                    let options: any[] = [];
                    question.options.forEach((option) => {
                      let opt = {
                        value: option.option_text,
                        id: option.id,
                        field_name: option.id,
                        label: option.option_text,
                      };
                      options = [...options, opt];
                    });
                    // console.log(' case 1', options);
                    metaModel.properties[question.id] = new SmMetaMultipleChoiceModel(
                      String(question.id),
                      String(question.id),
                      "singleChoice",
                      true,
                      "col-12 col-md-6",
                      1,
                      2,
                      question.question,
                      "number",
                      "",
                      false,
                      true,
                      true,
                      false,
                      0,
                      0,
                      false,
                      options,
                      "",
                      "id",
                      false,
                      false,
                      false,
                      false,
                      false,
                      false
                    );
                    break;
        
                  case 2: // Yes/No
                    let yesNoOptions: any[] = [
                      { value: 1, id: `${question.id}_yes`, field_name: "Yes", label: "Yes" },
                      { value: 0, id: `${question.id}_no`, field_name: "No", label: "No" },
                    ];
                    // console.log(' case 2', yesNoOptions);
                    metaModel.properties[question.id] = new SmMetaMultipleChoiceModel(
                      String(question.id), // Use a unique identifier for yes/no options
                      String(question.id), // Use the same identifier for consistency
                      "singleChoice",
                      true,
                      "col-12 col-md-6",
                      1,
                      2,
                      question.question,
                      "number",
                      "",
                      false,
                      true,
                      true,
                      false,
                      0,
                      0,
                      false,
                      yesNoOptions,
                      "",
                      "id",
                      false,
                      false,
                      false,
                      false,
                      false,
                      false
                    );
                    break;
        
                  case 3: // Ratings
                    // console.log(' case 3');
                    metaModel.properties[question.id] = new SmMetaInputModel(
                      String(question.id),
                      String(question.id),
                      "ratings",
                      true,
                      "col-12 col-md-6",
                      1,
                      1,
                      question.question,
                      "text",
                      "",
                      false,
                      true,
                      true,
                      false,
                      100,
                      1
                    ); break;
        
                  case 4: // Dropdown
                    // console.log(' case 4');
                    const dropdownOptions = question.dropdownOptions.map((item)=> ({
                        option_text: item
                    }))
                    metaModel.properties[question.id] = new SmMetaSelectModel(
                      String(question.id),
                      String(question.id),
                      "select",
                      true,
                      "col-12 col-md-6 col-lg-6",
                      1,
                      1,
                      question.question,
                      "select",
                      "",
                      false,
                      true,
                      true,
                      false,
                      0,
                      0,
                      false,
                      dropdownOptions,
                      "option_text",
                      "option_text"
                    ); break;
        
                  case 5: // TextArea
                    metaModel.properties[question.id] = new SmMetaTextAreaModel(
                      String(question.id),
                      String(question.id),
                      "SimpleTextarea",
                      true,
                      "col-12 col-md-6",
                      1,
                      1,
                      question.question,
                      "text",
                      "",
                      false,
                      true,
                      true,
                      false,
                      500,
                      1,
                      false,
                      false
                    ); break;
        
                  case 6: // Multiple Choice
                  // console.log(question,'mcqOptionsquestion');
        
                  let mcqoptions: any[] = [];
                  question.options.forEach((option) => {
                    let opt = {
                      value: option.option_text,
                      id: option.id,
                      field_name: option.id,
                      label: option.option_text,
                      selected: false
                    };
                    mcqoptions = [...mcqoptions, opt];
                  });
                    
                    metaModel.properties[question.id] = new SmMetaMultipleChoiceModel(
                      String(question.id),
                      String(question.id),
                      "multipleChoice",
                      true,
                      "col-12 col-md-6",
                      1,
                      2,
                      question.question,
                      "number",
                      "",
                      false,
                      true,
                      true,
                      false,
                      0,
                      0,
                      false,
                      mcqoptions,
                      "",
                      "id",
                      true,
                      false,
                      false,
                      false,
                      false,
                      false
                    );
                    break;
        
                   default:
                    console.warn(`Unknown question type: ${questionType}`);
                }
        
                // Set the selected category for the question
                // if (metaModel.properties[id]) {
                //   metaModel.properties[id]["selectedCategory"] = selected_category_text || "";
                // }
              });
              
              resolve(metaModel);
            })
        
          })
    }
}